<template>
  <path
    d="M7 6.00018C7.55 6.00018 8 6.45018 8 7.00018V17.0002C8 17.5502 7.55 18.0002 7 18.0002C6.45 18.0002 6 17.5502 6 17.0002V7.00018C6 6.45018 6.45 6.00018 7 6.00018ZM10.66 12.8202L16.43 16.8902C17.09 17.3602 18.01 16.8802 18.01 16.0702V7.93018C18.01 7.12018 17.1 6.65018 16.43 7.11018L10.66 11.1802C10.09 11.5802 10.09 12.4202 10.66 12.8202Z"
  />
</template>
